import type { ReactNode } from 'react'
import type { StyleProp, ViewStyle } from 'react-native'
import { Card as PaperCard } from 'react-native-paper'

interface CardProps {
    children: ReactNode
    style?: StyleProp<ViewStyle>
}

export function Card({ children, style }: CardProps) {
    return (
        <PaperCard mode="elevated" style={style}>
            {children}
        </PaperCard>
    )
}

Card.Content = PaperCard.Content
Card.Title = PaperCard.Title
Card.Actions = PaperCard.Actions
Card.Cover = PaperCard.Cover
